import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogPanel,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

import { useAddPassengers } from "../../api/use-claim-mutations";

interface AddPassengerDialogProps {
  claimId: string;
  open: boolean;
  onClose: () => void;
}

/** Port of the « Ajouter un passager » AlertModal of PassengerTable.vue. */
export function AddPassengerDialog({ claimId, open, onClose }: AddPassengerDialogProps) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const addPassengers = useAddPassengers(claimId);

  function handleConfirm() {
    onClose();
    addPassengers.mutate({ users: [{ firstName, lastName }] });
    setFirstName("");
    setLastName("");
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onClose();
        }
      }}
    >
      <DialogContent className="text-left sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Ajouter un passager</DialogTitle>
          <DialogDescription>Ajouter un passager au dossier.</DialogDescription>
        </DialogHeader>
        <DialogPanel className="divide-y-8 divide-transparent">
          <div>
            <Label htmlFor="add-passenger-first-name">Prénom</Label>
            <Input
              id="add-passenger-first-name"
              placeholder="Prénom"
              value={firstName}
              onChange={(event) => setFirstName(event.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="add-passenger-last-name">Nom de famille</Label>
            <Input
              id="add-passenger-last-name"
              placeholder="Nom de famille"
              value={lastName}
              onChange={(event) => setLastName(event.target.value)}
            />
          </div>
        </DialogPanel>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Annuler
          </Button>
          <Button onClick={handleConfirm}>Ajouter</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
